module.exports = __webpack_public_path__ + "img/emovis.7041c117.png";